import _ from "lodash/fp";

export const getIsChecked = (product, checkedProducts) =>
    Boolean(_.find((checkedProduct) => product.id === checkedProduct.id, checkedProducts));
